import { RolePermissions } from "../Common/permissions";
import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

export interface UserRoleDto extends RolePermissions {
  id: string;
  name: string;
  description: string;
  administrator: boolean;
}

export interface UserRoleUpsertDto extends RolePermissions {
  name: string;
  description: string;
}

export interface BusinessUserDto {
  id: string;
  emailAddress: string;
  userRoleId: string;
  hasSignedIn: boolean;
  isErrorRecipient: boolean;
  siteRestricted: boolean;
  siteIds: string[];
}

export interface BusinessUserCreateDto {
  emailAddress: string;
  userRoleId: string;
  addAsErrorRecipient: boolean;
  siteRestricted: boolean;
  siteIds: string[];
}

export interface BusinessUserUpdateDto {
  userRoleId: string;
  errorRecipient: boolean;
  siteRestricted: boolean;
  siteIds: string[];
}

export interface BusinessSiteDto {
  id: string;
  name: string;
}

export interface BusinessUsersDto {
  userRoles: UserRoleDto[];
  users: BusinessUserDto[];
  sites: BusinessSiteDto[];
}

const useGetUsers = (options?: QueryOptions<BusinessUsersDto>) => {
  const { selectedBusiness } = useUser();

  return useUserQuery<BusinessUsersDto>(
    { path: `/api/businesses/${selectedBusiness?.id}/users` },
    options);
}

export default useGetUsers;
